import React from "react";
import { UploadIcon } from "../icons";

export default function ArchiveButton({ isProcessing, onClick, disabled }) {
  return (
    <button className="btn-primary" onClick={onClick} disabled={isProcessing || disabled} type="button">
      {isProcessing ? (
        <>
          <div className="spinner" /> Processing...
        </>
      ) : (
        <>
          <UploadIcon /> Archive Email
        </>
      )}
    </button>
  );
}
